/* @flow */

import type {ReportRowData, ComparedActivityReportSummary} from 'nutshell-core/types';
import {combineReducers} from 'redux';

import * as actions from './quotes-report-actions';

const defaultState = {
    data: null,
    hasError: false,
    isLoading: true,
    numPages: null,
};

type SummaryState = {
    hasError: boolean,
    isLoading: boolean,
    data: ?ComparedActivityReportSummary<Array<ReportRowData>>,
    totals: ?ComparedActivityReportSummary<ReportRowData>,
};
const defaultSummaryState = {
    ...defaultState,
    totals: null,
};

export const summaryReducer = (
    state: SummaryState = defaultSummaryState,
    action: actions.QuotesReportAction
): SummaryState => {
    switch (action.type) {
        case actions.ActionTypes.QUOTES_REPORT_FETCH_SUMMARY_REQUEST:
            return {...state, isLoading: true};
        case actions.ActionTypes.QUOTES_REPORT_FETCH_SUMMARY_SUCCESS:
            return {
                ...state,
                data: action.payload.data,
                totals: action.payload.totals,
                isLoading: false,
                hasError: false,
            };
        case actions.ActionTypes.QUOTES_REPORT_FETCH_SUMMARY_FAILURE:
            return {...state, isLoading: false, hasError: true};
        default:
            return state;
    }
};

// $FlowFixMe upgrading Flow to v0.92.1 on web
export const quotesReportReducer = combineReducers({
    summary: summaryReducer,
});

export type QuotesReportState = {
    summary: SummaryState,
};
